export function formatThinkingContent(text: string): string {
  if (!text) return "";

  return text
    .replace(/\s*\*\*([^*\n]+)\*\*[ \t]*(?=\n\n|\n*$)/g, "\n\n#### $1\n\n")
    .replace(/\n{3,}/g, "\n\n")
    .replace(/^\n+/, "");
}

// Thinking is made up of sections, each introduced by a `#### ` heading
// (produced by formatThinkingContent from Claude's bold section headers).
// While streaming we surface the heading of the section currently being
// written as the block's label.
export function getLatestThinkingHeading(formatted: string): string | null {
  const lines = formatted.split("\n");

  for (let i = lines.length - 1; i >= 0; i--) {
    const match = /^#### (.+)$/.exec(lines[i]);
    if (match) return match[1].trim();
  }

  return null;
}

// While streaming we only want to surface the body of the section currently
// being written, i.e. everything after the last heading. The heading itself
// is shown separately as the block's label.
export function getLatestThinkingSection(formatted: string): string {
  const lines = formatted.split("\n");

  let lastHeadingIndex = -1;
  for (let i = 0; i < lines.length; i++) {
    if (/^#### /.test(lines[i])) lastHeadingIndex = i;
  }

  // No heading yet — show everything written so far.
  if (lastHeadingIndex < 0) return formatted;

  return lines
    .slice(lastHeadingIndex + 1)
    .join("\n")
    .trim();
}
